import React, { useState } from 'react';
import CoinPlan from '../component/table/CoinPlan';
import VIPPlan from '../component/table/VIPPlan';
import RcoinUsdSetting from '../component/table/RcoinUsdSetting';

const MainPlan = () => {
  const [type, setType] = useState(() => {
    return localStorage.getItem('planTab') || 'coinPlan';
  });

  const handleTabChange = (newType) => {
    setType(newType);
    localStorage.setItem('planTab', newType);
  };

  return (
    <div>
      {/* Tabs */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="my-2">
            <button
              className={`btn btn-sm ${type === 'coinPlan' ? 'btn-success' : 'disabledBtn'}`}
              onClick={() => handleTabChange('coinPlan')}
            >
              Coin Plan
            </button>

            <button
              className={`btn btn-sm ms-3 ${type === 'vipPlan' ? 'btn-danger' : 'disabledBtn'}`}
              onClick={() => handleTabChange('vipPlan')}
            >
              VIP Plans
            </button>

            <button
              className={`btn btn-sm ms-3 ${type === 'rcoinUsd' ? 'btn-warning' : 'disabledBtn'}`}
              onClick={() => handleTabChange('rcoinUsd')}
            >
              rCoin → USD
            </button>
          </div>
        </div>
      </div>

      {type === 'coinPlan' && <CoinPlan />}
      {type === 'vipPlan' && <VIPPlan />}
      {type === 'rcoinUsd' && <RcoinUsdSetting />}
    </div>
  );
};

export default MainPlan;
